var React = require('react');

function CeIconMobile (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"fill":"#005BA2","d":"M0 0h61v61H0z","key":0}),React.createElement("path",{"d":"M17.5 16.5h27v27h-27z","key":1}),React.createElement("path",{"d":"M22.41 31.517v5.143L31 41.571l8.59-4.911v-5.143L31 36.43l-8.59-4.912zM31 18.43l-13.5 7.714L31 33.857l11.045-6.313v8.885H44.5V26.143L31 18.429z","fill":"#FFF","key":2})]));
}

CeIconMobile.displayName = "CeIconMobile";

CeIconMobile.defaultProps = {"width":"61","height":"61"};

module.exports = CeIconMobile;

CeIconMobile.default = CeIconMobile;
